import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistCombineReducers } from 'redux-persist';

import contentReducer, { ContentState } from '../features/content/contentSlice';
import logReducer, { LogState } from '../features/log/logSlice';
import pilgrimageReducer, { PilgrimageState } from '../features/pilgrimage/pilgrimageSlice';
import userReducer, { UserState } from '../features/user/userSlice';
import { CapacitorStore } from './capacitor-store';

const persistConfig = {
  key: 'root',
  storage: new CapacitorStore(),
  debug: true
};

export const store = configureStore({
  reducer: persistCombineReducers(persistConfig, {
    content: contentReducer,
    log: logReducer,
    pilgrimage: pilgrimageReducer,
    user: userReducer
  })
});

export const persistor = persistStore(store);

export type AppState = {
  content: ContentState;
  log: LogState;
  pilgrimage: PilgrimageState;
  user: UserState;
}